module.exports = __webpack_public_path__ + "img/pellets-silowagen.2fa2f95.webp";